var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-10"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('apex-charts',{attrs:{"type":"area","options":_vm.chartOptions,"series":_vm.series,"height":_vm.height}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }